import script from "./ClipTimeline.vue?vue&type=script&setup=true&lang=js"
export * from "./ClipTimeline.vue?vue&type=script&setup=true&lang=js"

import "./ClipTimeline.vue?vue&type=style&index=0&id=c1e265cc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c1e265cc"]])

export default __exports__